import * as React from 'react';
// ---
const DEFAULT_CONFIGURATION = ({ options })=>{
    return options;
};
// ---
const PositioningConfigurationContext = React.createContext(undefined);
/**
 * A context provider for the positioning configuration.
 *
 * Accepts a function that takes the positioning options and returns them modified.
 */ export const PositioningConfigurationProvider = PositioningConfigurationContext.Provider;
export const usePositioningConfiguration = ()=>{
    var _React_useContext;
    return (_React_useContext = React.useContext(PositioningConfigurationContext)) !== null && _React_useContext !== void 0 ? _React_useContext : DEFAULT_CONFIGURATION;
};
